import { render, staticRenderFns } from "./PersonalInfoProvider.vue?vue&type=template&id=fb90dd0c&scoped=true&"
import script from "./PersonalInfoProvider.vue?vue&type=script&lang=js&"
export * from "./PersonalInfoProvider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb90dd0c",
  null
  
)

export default component.exports